import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
export const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 right-6 z-50 animate-fade-in" data-id="element-194">
      <a href="tel:08000554969" className="flex items-center space-x-3 bg-blue-500 text-white px-6 py-4 rounded-full shadow-2xl hover:bg-blue-600 transition-all hover:scale-105" data-id="element-195">
        <Phone className="w-5 h-5" data-id="element-196" />
        <span className="font-semibold" data-id="element-197">Request a Callout</span>
      </a>
    </div>;
};